"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZForm = exports.FormDispatchContext = exports.FormContext = void 0;
const ZAlert_1 = require("../ZAlert/ZAlert");
const react_1 = __importDefault(require("react"));
const lodash_1 = __importDefault(require("lodash"));
exports.FormContext = react_1.default.createContext({
    submit: null,
    onFormChange: undefined,
    onFormSubmit: undefined,
    debug: false,
    formState: { valid: false, touched: false, submitted: false, fields: {} },
    formDispatch: null
});
exports.FormContext.displayName = "FormContext";
exports.FormDispatchContext = react_1.default.createContext({ formDispatch: null, setFormDispatch: null });
exports.FormDispatchContext.displayName = "FormDispatchContext";
exports.ZForm = react_1.default.memo((props) => {
    const [formState, setFormState] = react_1.default.useState({});
    const [formDispatch, setFormDispatch] = react_1.default.useState(null);
    const debug = process.env.NODE_ENV !== "production" && props.debug;
    react_1.default.useEffect(() => {
        if (debug) {
            // eslint-disable-next-line no-console
            console.log("form debugging is enabled");
        }
    }, [debug]);
    const { onFormChange: onFormChangeFromProps } = props;
    const onFormChange = react_1.default.useCallback((valid, values) => {
        onFormChangeFromProps && onFormChangeFromProps(valid, values);
        setFormState({ ...formState, valid, fields: values });
    }, [onFormChangeFromProps, formState]);
    const { issueAlert } = ZAlert_1.useAlerts();
    const { onFormSubmit } = props;
    const onFormSubmitCallback = react_1.default.useCallback(values => {
        try {
            const allTouched = Object.keys(values).reduce(function (prev, curr, index, array) {
                lodash_1.default.set(prev, curr, { ...values[curr], touched: true });
                return prev;
            }, {});
            setFormState(state => ({
                ...state,
                fields: allTouched,
                submitted: true
            }));
            if (!formState.valid)
                throw new Error("RequiredFieldsMessage");
            const finalResult = {};
            lodash_1.default.each(allTouched, (obj, key) => {
                if (!obj.hidden) {
                    finalResult[key] = obj.value;
                }
            });
            onFormSubmit && onFormSubmit(finalResult);
        }
        catch (e) {
            issueAlert({ type: "error", message: e.message });
        }
    }, [onFormSubmit, setFormState, formState.valid, issueAlert]);
    const submit = react_1.default.useCallback(() => {
        formState.fields && onFormSubmitCallback(formState.fields);
    }, [onFormSubmitCallback, formState.fields]);
    const contextValue = react_1.default.useMemo(() => ({
        debug,
        formDispatch,
        formState,
        onFormChange,
        onFormSubmit,
        submit
    }), [debug, formDispatch, formState, onFormChange, onFormSubmit, submit]);
    const dispatchContextValue = react_1.default.useMemo(() => ({ formDispatch, setFormDispatch }), [formDispatch, setFormDispatch]);
    const { render } = props;
    const form = react_1.default.useMemo(() => (react_1.default.createElement(exports.FormDispatchContext.Provider, { value: dispatchContextValue },
        react_1.default.createElement(exports.FormContext.Provider, { value: contextValue },
            react_1.default.createElement(react_1.default.Fragment, null, render(contextValue))))), [contextValue, dispatchContextValue, render]);
    return form;
}, (prev, next) => {
    return lodash_1.default.isEqual(prev, next);
});
//# sourceMappingURL=ZForm.js.map